import { Translate } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconVictory } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useDeclareVictoryLink } from 'src/app/pages/starterDashboardV2/shared/hooks';

export function ReachedYourGoal() {
	const {
		data: { declareVictoryLink },
		actions: { onDeclareVictoryClick },
	} = useDeclareVictoryLink();

	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	if (petition.status !== 'PUBLISHED') {
		return null;
	}

	return (
		<Flex
			p={16}
			mt={24}
			backgroundColor="primary-greyBackground"
			sx={{
				alignItems: 'center',
				justifyContent: 'space-between',
				borderRadius: 'standard',
				flexDirection: 'row',
				flex: '1 1 auto',
				flexWrap: 'wrap',
				width: '100%',
			}}
			data-testid=""
		>
			<Flex sx={{ gap: 8, alignItems: 'center' }}>
				<Box
					sx={{
						width: '32px',
						height: '32px',
						display: ['none', 'flex'],
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Icon icon={iconVictory} size={24} color="primary-changeRed" />
				</Box>
				<Box sx={{ height: '32px', display: 'flex', alignItems: 'center' }}>
					<Text size="small">
						<Translate value="corgi.petition.starter_dashboard.petition_overview.reached_your_goal.ask" />
					</Text>
				</Box>
			</Flex>
			<ButtonLink
				to={declareVictoryLink}
				variant="secondaryEmphasis"
				onClick={onDeclareVictoryClick}
				size="small"
				data-qa="petition-overview-declare-victory-cta"
				data-testid="petition-overview-declare-victory-cta"
			>
				<Text size="small">
					<Translate value="corgi.petition.starter_dashboard.petition_overview.reached_your_goal.cta" />
				</Text>
			</ButtonLink>
		</Flex>
	);
}
